import { vuex as dashboard } from './dashboard'
import { vuex as balance } from './balance'
import { vuex as catalog } from './catalog'
import { vuex as tradle } from './tradle'
import { vuex as user } from './user'
import { vuex as auth } from './auth'

export default {
  dashboard,
  catalog,
  balance,
  tradle,
  user,
  auth
}
